/**
 * @Auther: Qsan
 * @Date：2018年12月12日 17:27
 * @Desc：element-ui组件按需加载
 */

import {
    Row,
    Col,
    Input,
    Select,
    Option,
    Form,
    FormItem,
    Loading,
    Button,
    MessageBox,
    Message,
    Tabs,
    TabPane,
    Breadcrumb,
    BreadcrumbItem,
    Dialog,
    Tooltip,
    Popover,
    Tree,
    Table,
    TableColumn,
    Pagination,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Radio,
    RadioGroup,
    Menu,
    MenuItem,
    DatePicker,
    Autocomplete,
    Popconfirm,
    Checkbox,
    CheckboxGroup,
    Image,
    Collapse,
    CollapseItem,
    Upload
} from 'element-ui'
const components = [
    Row,
    Col,
    Button,
    Input,
    Select,
    Option,
    Form,
    FormItem,
    MessageBox,
    Message,
    Tabs,
    TabPane,
    Breadcrumb,
    BreadcrumbItem,
    Dialog,
    Tooltip,
    Tree,
    Popover,
    Table,
    TableColumn,
    Pagination,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Radio,
    RadioGroup,
    Menu,
    MenuItem,
    DatePicker,
    Autocomplete,
    Popconfirm,
    Checkbox,
    CheckboxGroup,
    Image,
    Collapse,
    CollapseItem,
    Upload
]

const install = function (Vue, opts = {}) {
    components.forEach(component => {
        Vue.component(component.name, component)
    })

    Vue.use(Loading.directive)

    Vue.prototype.$ELEMENT = {
        size: opts.size || '',
        zIndex: opts.zIndex || 2000
    }

    Vue.prototype.$loading = Loading.service
    Vue.prototype.$msgbox = MessageBox
    Vue.prototype.$alert = MessageBox.alert
    Vue.prototype.$confirm = function (opts) {
        opts = Object.assign(
            {
                title: '',
                type: '',
                confirmText: '确定',
                cancelText: '取消',
                ok: () => {},
                no: () => {}
            },
            opts
        )

        MessageBox.confirm(opts.title, '提示', {
            confirmButtonText: opts.confirmText,
            cancelButtonText: opts.cancelText,
            type: opts.type || 'warning'
        })
            .then(() => {
                opts.ok()
            })
            .catch(() => {
                opts.no()
            })
    }
    Vue.prototype.$prompt = MessageBox.prompt
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$message = Message
}

export default {
    install
}



// WEBPACK FOOTER //
// ./src/components/libs/element-ui/index.js